import { paths } from '@omnea-digital/file-storage-client'
import { GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'

interface Params {
  authorization: string
}

export class FileStorageApiClient {
  POST
  GET

  constructor({ authorization }: Params) {
    const { POST, GET } = createClient<paths>({
      baseUrl: ServiceUrls.FILE_STORAGE,
      headers: { Authorization: authorization },
    })
    this.POST = POST
    this.GET = GET
  }
}

export type FileStorageResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>

export type FileStorageUploadResponseItem = NonNullable<FileStorageResponse<'/upload', 'post'>['data']>[number]
